import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputType, KENDO_FORMFIELD, KENDO_TEXTBOX } from '@progress/kendo-angular-inputs';
import { KENDO_LABEL } from '@progress/kendo-angular-label';
import { ControlWrapperComponent } from '@unity/forms/composed/control-wrapper/control-wrapper.component';

@Component({
  selector: 'unity-textbox-control',
  standalone: true,
  imports: [KENDO_FORMFIELD, KENDO_TEXTBOX, KENDO_LABEL, ReactiveFormsModule, ControlWrapperComponent],
  templateUrl: './textbox-control.component.html',
  styleUrl: './textbox-control.component.scss',
})
export class TextboxControlComponent {
  public readonly $control = input.required<FormControl>({ alias: 'control' });
  public readonly $displayName = input.required<string>({ alias: 'displayName' });
  public readonly $description = input.required<string>({ alias: 'description' });

  public readonly $type = input<InputType>('text', { alias: 'type' });
  public readonly $clearButton = input<boolean>(false, { alias: 'clearButton' });
  public readonly $suffix = input<string>(undefined, { alias: 'suffix' });
  public readonly $showHint = input(true, { alias: 'showHint' });
}
